import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GET_MYACCOUNT_ADDRESS_SEARCH, UPDATE_PREMISE_ID } from "../../../../Urls.js";

const defaultState = {
  "region": "",
  "crm_premise_id": "",
  "community_name": "",
  "street_address": "",
  "city": "",
  "state": "",
  "zip": "",
  "fiber_service": {
    "selected": false,
    "available": false,
    "pre_installed": false,
    "active": false,
    "active_users": []
  },
  "gas_service": {
    "selected": false,
    "available": false,
    "pre_installed": false,
    "meter_disconnected": true,
    "active": false,
    "active_users": []
  },
  "voip_service": {
    "selected": false,
    "available": false,
    "pre_installed": false,
    "active": false,
    "active_users": []
  },
  "cable_service": {
    "selected": false,
    "available": false,
    "pre_installed": false,
    "active": false,
    "active_users": []
  }
};

const initialState = {
  search_premise: { loader: false, serach_term: "", data: [] },
  selected_premise: { loader: false, data: defaultState },
  update_premise_id: { loader: false, data: {} },
  searchedCentricUserPremise: { loader: false, serach_term: "", data: {} },
  searchedMyAccountdAddress: { data: [], loader: false }
};

export const getPremiseDetailsByPremiseId = createAsyncThunk(
  "premiseSlice/getPremiseDetailsByPremiseId",
  async (premise_id) => {
    const response = await axios.get(
      `api/v1/premise/get-premise-service-point-details?premise_id=${premise_id}`
    );
    return response;
  }
);

//Centric user premise search.
export const getSearchedPremiseDetails = createAsyncThunk(
  "premiseSlice/getCentricUserSearchedPremiseDetails",
  async (premise_id) => {
    const response = await axios.get(
      `api/v1/premise/get-premise-service-point-details?premise_id=${premise_id}`
    );
    return response;
  }
);

// Searched by account
export const SearchMyAccountAddress = createAsyncThunk(
  "app/get/getSearchMyAccounts",
  async (addressOremailOrPhone) => {
    const resAccounts = await axios.get(GET_MYACCOUNT_ADDRESS_SEARCH + addressOremailOrPhone);
    return resAccounts;
  }
);


export const searchPremisesByTerm = createAsyncThunk(
  "premiseSlice/searchPremisesByTerMyaccount",
  async (serach_term) => {
    const response = await axios.get(
      `api/v1/premise/search-premise?search_Key=${serach_term}`
    );
    return response;
  }
);

export const attachedPrimiseId = createAsyncThunk(
  "premiseSlice/updatePrimiseId",
  async (data) => {
    const response = await axios.post(UPDATE_PREMISE_ID, data);
    return response;
  }
);

export const premiseSlice = createSlice({
  name: "premiseSlice/premiseSlice",
  initialState,
  reducers: {
    updateSelectedPremise: (state, action) => {
      state.selected_premise.data = action?.payload;
    },
    clearAddressList(state) {
      state.search_premise.data = [];
      state.search_premise.serach_term = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getPremiseDetailsByPremiseId.pending, (state) => {
        state.selected_premise.loader = true;
        state.selected_premise.data = defaultState;
      })
      .addCase(getPremiseDetailsByPremiseId.fulfilled, (state, action) => {
        state.selected_premise.loader = false;
        state.selected_premise.data = action?.payload?.data?.data;
      })
      .addCase(getPremiseDetailsByPremiseId.rejected, (state) => {
        state.selected_premise.loader = false;
        state.selected_premise.data = defaultState;
      })

      // Centric user Premise search
      .addCase(getSearchedPremiseDetails.pending, (state) => {
        state.searchedCentricUserPremise.loader = true;
        state.searchedCentricUserPremise.data = defaultState;
      })
      .addCase(getSearchedPremiseDetails.fulfilled, (state, action) => {
        state.searchedCentricUserPremise.loader = false;
        state.searchedCentricUserPremise.data = action?.payload?.data?.data;
      })
      .addCase(getSearchedPremiseDetails.rejected, (state) => {
        state.searchedCentricUserPremise.loader = false;
        state.searchedCentricUserPremise.data = defaultState;
      })

      // MY ACCOUNT Address Search
      .addCase(SearchMyAccountAddress.pending, (state) => {
        state.searchedMyAccountdAddress.loader = true;
      })
      .addCase(SearchMyAccountAddress.fulfilled, (state, action) => {
        state.searchedMyAccountdAddress.loader = false;
        state.searchedMyAccountdAddress.data = action?.payload?.data?.data;
      })
      .addCase(SearchMyAccountAddress.rejected, (state) => {
        state.searchedMyAccountdAddress.loader = false;
        state.searchedMyAccountdAddress.data = [];
      })


      // update premise id
      .addCase(attachedPrimiseId.pending, (state) => {
        state.update_premise_id.loader = true;
      })
      .addCase(attachedPrimiseId.fulfilled, (state, action) => {
        state.update_premise_id.loader = false;
        state.update_premise_id.data = action?.payload?.data?.data;
      })
      .addCase(attachedPrimiseId.rejected, (state) => {
        state.update_premise_id.loader = false;
      })

      .addCase(searchPremisesByTerm.pending, (state) => {
        state.search_premise.loader = true;
        state.search_premise.data = [];
        state.selected_premise.data = defaultState;
      })
      .addCase(searchPremisesByTerm.fulfilled, (state, action) => {
        state.search_premise.loader = false;
        state.search_premise.data = action?.payload?.data?.data;
        state.selected_premise.data = defaultState;
      })
      .addCase(searchPremisesByTerm.rejected, (state) => {
        state.search_premise.loader = false;
        state.search_premise.data = [];
        state.selected_premise.data = defaultState;
      });
  },
});

export const {
  updateSelectedPremise,
  clearAddressList,
} = premiseSlice.actions;

export default premiseSlice.reducer;
